
import Vue from 'vue'
import gsap from 'gsap'
import { mapper } from '@/stores/store'
import { API_STATUS_PENDING } from '@/constants'
import ScidUser from '@/components/ScidUser.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import Loader from '@/components/Loader.vue'

export default Vue.extend({
  name: 'ScidUserBar',
  components: { ScidUser, BaseButton, Loader },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapper('auth', ['logoutStatus']),
    isLoggingOut(): boolean {
      return this.logoutStatus === API_STATUS_PENDING
    },
  },
  methods: {
    ...mapper('auth', ['ssoLogin']),
    onEnter(el: any, done: any) {
      gsap.fromTo(
        el,
        { y: '100%' },
        { duration: 0.5, y: '0%', ease: 'power2.inOut', onComplete: done }
      )
    },
    onLeave(el: any, done: any) {
      gsap.to(el, { duration: 0.5, y: '100%', ease: 'power2.inOut', onComplete: done })
    },
    onClickSwitchAccount() {
      this.ssoLogin()
    },
  },
})
